import { useState } from 'react';
import { Box, Snackbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DeviceTable, DeviceLogsDialog } from '../components';
import { useDevices } from '../hooks';
import type { Device } from '@/types/domain';

/**
 * 设备管理页面
 */
export default function Devices() {
  const { t } = useTranslation();
  const {
    devices,
    loading,
    error,
    success,
    lock,
    unlock,
    deleteDevice,
    clearMessages,
  } = useDevices();

  const [logsDevice, setLogsDevice] = useState<Device | null>(null);

  const handleCloseLogsDialog = () => {
    setLogsDevice(null);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {t('devices.title')}
      </Typography>

      <DeviceTable
        devices={devices}
        loading={loading}
        onLock={lock}
        onUnlock={unlock}
        onDelete={deleteDevice}
        onViewLogs={setLogsDevice}
      />

      <DeviceLogsDialog
        open={!!logsDevice}
        device={logsDevice}
        onClose={handleCloseLogsDialog}
      />

      {/* Success Snackbar */}
      <Snackbar
        open={!!success}
        autoHideDuration={3000}
        onClose={clearMessages}
        message={success || ''}
      />

      {/* Error Snackbar */}
      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        onClose={clearMessages}
        message={error || ''}
      />
    </Box>
  );
}
